// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNiA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZG90cyBmaWxsPSIjOTk5IiBvcGFjaXR5PSIwLjYiPgo8Y2lyY2xlIGN4PSI1IiBjeT0iNSIgcj0iMSIvPgo8Y2lyY2xlIGN4PSI1IiBjeT0iMyIgcj0iMSIvPgo8Y2lyY2xlIGN4PSI1IiBjeT0iMSIgcj0iMSIvPgo8Y2lyY2xlIGN4PSIzIiBjeT0iNSIgcj0iMSIvPgo8Y2lyY2xlIGN4PSIzIiBjeT0iMyIgcj0iMSIvPgo8Y2lyY2xlIGN4PSIxIiBjeT0iNSIgcj0iMSIvPgo8L2RvdHM+Cjwvc3ZnPgo=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === INSIGHTS SIDEBAR STYLES === */

/* Remove page scrollbar when insights sidebar is open */
html:has(.insights-sidebar-redesigned.open),
body:has(.insights-sidebar-redesigned.open) {
    overflow-y: hidden;
}

/* Main container - SIDEBAR LAYOUT */
.insights-sidebar-redesigned {
    position: fixed;
    top: 0;
    right: 0;
    width: 400px;
    height: 100vh;
    background: rgba(10, 10, 12, 0.95);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    border-left: 1px solid rgba(75, 85, 99, 0.2);
    display: flex;
    flex-direction: column;
    z-index: 100002;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
}

.insights-sidebar-redesigned.open {
    transform: translateX(0);
}

/* Stacked mode styles */
.insights-sidebar-redesigned.stacked {
    position: static;
    width: 100%;
    height: auto;
    transform: none;
    background: transparent;
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    border: none;
    box-shadow: none;
    z-index: auto;
}

.insights-sidebar-redesigned.stacked .insights-content {
    padding: 0.5rem 0;
}

.insights-sidebar-redesigned.stacked .stacked-header {
    padding: 1rem 1rem 0 1rem;
    border-bottom: 1px solid rgba(75, 85, 99, 0.1);
    margin-bottom: 0.25rem;
}

/* Sidebar toggle button */
.sidebar-toggle {
    position: fixed;
    top: 20px;
    right: 20px;
    width: 48px;
    height: 48px;
    background: rgba(15, 15, 17, 0.9);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(75, 85, 99, 0.3);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 100003;
    transition: all 0.2s ease;
    color: rgba(255, 255, 255, 0.8);
}

.sidebar-toggle:hover {
    background: rgba(15, 15, 17, 1);
    border-color: rgba(34, 197, 94, 0.4);
    color: rgba(34, 197, 94, 0.9);
    transform: scale(1.05);
}

.sidebar-toggle svg {
    width: 20px;
    height: 20px;
    stroke-width: 2;
}

/* Sidebar header */
.sidebar-header {
    padding: 1rem;
    border-bottom: 1px solid rgba(75, 85, 99, 0.2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(15, 15, 17, 0.5);
    flex-shrink: 0;
}

.sidebar-title {
    font-size: 1rem;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    letter-spacing: -0.025em;
}

.sidebar-close {
    background: none;
    border: none;
    color: rgba(156, 163, 175, 0.7);
    cursor: pointer;
    padding: 0.25rem;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.sidebar-close:hover {
    color: rgba(156, 163, 175, 1);
    background: rgba(156, 163, 175, 0.1);
}

.sidebar-close svg {
    width: 16px;
    height: 16px;
    stroke-width: 2;
}

/* Backdrop overlay for mobile */
.sidebar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100001;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    display: none; /* Hidden by default, shown on mobile */
}

.sidebar-backdrop.visible {
    opacity: 1;
    visibility: visible;
}

/* Scrollable content area */
.insights-content {
    flex: 1 1 auto;
    min-height: 0; /* critical to prevent clipping */
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0.5rem; /* Reduced from 0.75rem to minimize overall spacing */
    display: flex;
    flex-direction: column;
    gap: 0.25rem; /* Reduced from 0.75rem to bring sections much closer */
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    /* Show native scrollbar for the sidebar */
    scrollbar-width: auto;
    -ms-overflow-style: auto;
    position: relative; /* for custom scrollbar positioning */
}

.insights-content::-webkit-scrollbar { width: 8px; height: 8px; }

.insights-content::-webkit-scrollbar-track {
    background: transparent;
}

.insights-content::-webkit-scrollbar-thumb { background-color: rgba(75, 85, 99, 0.4); border-radius: 3px; }

.insights-content::-webkit-scrollbar-thumb:hover {
    background-color: rgba(75, 85, 99, 0.7);
}



/* === HERO CARD === */
.hero-card {
    background: linear-gradient(135deg, 
        rgba(15, 15, 17, 0.95) 0%,
        rgba(30, 30, 35, 0.8) 100%);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(75, 85, 99, 0.2);
    border-radius: 12px;
    padding: 1rem;
    position: relative;
    overflow: hidden;
}

.hero-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, 
        transparent, 
        rgba(34, 197, 94, 0.3), 
        transparent);
}

.hero-card-empty {
    text-align: center;
    padding: 1.5rem 1rem;
}

.hero-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
}

.hero-empty-icon {
    width: 32px;
    height: 32px;
    color: rgba(156, 163, 175, 0.6);
    margin-bottom: 0.25rem;
}

.hero-empty-icon svg {
    width: 100%;
    height: 100%;
    stroke-width: 1;
}

.hero-empty-state h3 {
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.125rem;
    font-weight: 600;
    margin: 0;
}

.hero-empty-state p {
    color: rgba(156, 163, 175, 0.7);
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0;
    max-width: 280px;
}

/* Company hero card - Compact centered design */
.hero-card-company .hero-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1rem;
}



.hero-logo {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.hero-logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.hero-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.5rem;
}

.hero-symbol-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
}

.hero-symbol {
    font-size: 1.75rem;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.025em;
    margin: 0;
}

.hero-name {
    font-size: 0.9rem;
    color: rgba(156, 163, 175, 0.9);
    font-weight: 500;
    margin: 0;
}

.hero-metrics {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.5rem;
}

.hero-metric-primary {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
}

.metric-value {
    font-size: 1.5rem;
    font-weight: 600;
    color: #ffffff;
}

.metric-change {
    font-size: 1rem;
    font-weight: 600;
    padding: 0.375rem 0.75rem;
    border-radius: 8px;
}

.metric-change.positive {
    color: #10b981;
    background: rgba(16, 185, 129, 0.15);
}

.metric-change.negative {
    color: #ef4444;
    background: rgba(239, 68, 68, 0.15);
}

/* Keyword hero card - Compact centered design */
.hero-card-keyword .hero-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 1rem;
}

.hero-keyword-icon {
    width: 40px;
    height: 40px;
    color: rgba(34, 197, 94, 0.85);
    flex-shrink: 0;
}

.hero-keyword-icon svg {
    width: 100%;
    height: 100%;
    stroke-width: 1.5;
}

.hero-keyword-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.5rem;
}

.hero-keyword-name {
    font-size: 1.75rem;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: -0.025em;
    margin: 0;
}

.hero-keyword-type {
    font-size: 0.875rem;
    color: rgba(156, 163, 175, 0.7);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: 500;
    margin: 0;
}

/* === COMPANY OVERVIEW === */
.overview-section {
    background: rgba(15, 15, 17, 0.4);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(75, 85, 99, 0.15);
    border-radius: 12px;
    padding: 1.5rem;
}

/* === COMPACT HERO CARD === */
.hero-card-compact {
    background: rgba(15, 15, 17, 0.4);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    border: 2px solid rgba(34, 197, 94, 0.3);
    border-radius: 8px;
    padding: 0.375rem 0.5rem;
    margin: 0; /* Removed bottom margin since overview section margins are gone */
    box-shadow: 
        0 4px 12px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(34, 197, 94, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    position: relative;
}

.hero-card-compact::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.02) 0%, rgba(34, 197, 94, 0.05) 100%);
    border-radius: 6px;
    pointer-events: none;
}

.hero-content-horizontal {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    position: relative;
    z-index: 1;
}

/* For keyword cards, center everything */
.hero-card-keyword-compact .hero-content-horizontal {
    flex-direction: row;
    text-align: center;
}

.hero-logo-compact {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.hero-logo-compact img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.hero-info-compact {
    flex: 0 1 auto;
    min-width: 0;
    text-align: center;
}

.hero-symbol-compact {
    font-size: 0.8rem;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.98);
    line-height: 1.1;
    letter-spacing: 0.025em;
}

.hero-name-compact {
    font-size: 0.65rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
}



/* Keyword compact styles */
.hero-keyword-icon-compact {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(34, 197, 94, 0.8);
    background: rgba(34, 197, 94, 0.1);
    border: 1px solid rgba(34, 197, 94, 0.2);
    border-radius: 4px;
}

.hero-keyword-icon-compact svg {
    width: 12px;
    height: 12px;
    stroke-width: 2.5;
}

.hero-keyword-info-compact {
    flex: 1;
    min-width: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.hero-keyword-name-compact {
    font-size: 0.8rem;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.98);
    line-height: 1.1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: 0.025em;
}

.hero-keyword-type-compact {
    font-size: 0.65rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.2;
    margin-top: 1px;
}

/* === COMPACT COMPANY OVERVIEW === */
.overview-section-compact {
    background: rgba(15, 15, 17, 0.3);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(75, 85, 99, 0.1);
    border-radius: 8px;
}


.company-name-compact {
    font-size: 1rem;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 0.25rem 0;
    line-height: 1.2;
}

.exchange-info-compact {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    color: rgba(156, 163, 175, 0.8);
}

.symbol-compact {
    font-weight: 500;
    color: rgba(34, 197, 94, 0.9);
}

.exchange-compact {
    color: rgba(156, 163, 175, 0.6);
}

.metrics-grid-compact {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.375rem;
    margin-bottom: 0.5rem;
}

.metric-item-compact {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
}

.metric-label-compact {
    font-size: 0.625rem;
    color: rgba(156, 163, 175, 0.6);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 500;
}

.metric-value-compact {
    font-size: 0.75rem;
    color: #ffffff;
    font-weight: 500;
    line-height: 1.2;
}

.description-compact {
    border-top: 1px solid rgba(75, 85, 99, 0.15);
    padding-top: 0.5rem;
}

.description-compact p {
    font-size: 0.75rem;
    color: rgba(209, 213, 219, 0.8);
    line-height: 1.4;
    margin: 0 0 0.375rem 0;
}

.website-link-compact {
    display: inline-flex;
    align-items: center;
    font-size: 0.7rem;
    color: rgba(96, 165, 250, 0.8);
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;
}

.website-link-compact:hover {
    color: rgba(96, 165, 250, 1);
}

/* Enhanced Overview Header */
.overview-header {
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid rgba(75, 85, 99, 0.2);
}

.overview-title-row {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.overview-company-name {
    font-size: 1.25rem;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    line-height: 1.3;
}

.overview-exchange-info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: rgba(156, 163, 175, 0.8);
}

.overview-symbol {
    font-weight: 600;
    color: rgba(96, 165, 250, 0.9);
}

.overview-exchange {
    color: rgba(156, 163, 175, 0.7);
}

/* Enhanced Metrics Grid */
.overview-metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 0.75rem;
    margin-bottom: 1.5rem;
}

.overview-metric-card {
    background: rgba(30, 30, 35, 0.5);
    border: 1px solid rgba(75, 85, 99, 0.2);
    border-radius: 8px;
    padding: 0.875rem;
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    transition: all 0.2s ease;
}

.overview-metric-card:hover {
    background: rgba(30, 30, 35, 0.7);
    border-color: rgba(75, 85, 99, 0.3);
    transform: translateY(-1px);
}

.overview-metric-card .metric-label {
    font-size: 0.75rem;
    font-weight: 500;
    color: rgba(156, 163, 175, 0.8);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0;
}

.overview-metric-card .metric-value {
    font-size: 0.9rem;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    word-break: break-word;
}

/* Company Description */
.overview-description {
    margin-bottom: 1.5rem;
}

.overview-description h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 0.75rem 0;
}

.overview-description p {
    font-size: 0.875rem;
    line-height: 1.6;
    color: rgba(209, 213, 219, 0.9);
    margin: 0;
}

/* Website Link */
.overview-website {
    margin-top: 1rem;
}

.website-link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: rgba(34, 197, 94, 0.12);
    border: 1px solid rgba(34, 197, 94, 0.25);
    border-radius: 8px;
    color: rgba(34, 197, 94, 0.95);
    text-decoration: none;
    font-size: 0.875rem;
    font-weight: 500;
    transition: all 0.2s ease;
}

.website-link:hover {
    background: rgba(34, 197, 94, 0.18);
    border-color: rgba(34, 197, 94, 0.35);
    color: #22c55e;
    transform: translateY(-1px);
}

.website-link svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

.overview-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.overview-description p {
    color: rgba(209, 213, 219, 0.9);
    font-size: 0.875rem;
    line-height: 1.6;
    margin: 0;
}

.overview-metrics {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
}

.overview-metric {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.overview-metric .metric-label {
    font-size: 0.75rem;
    color: rgba(156, 163, 175, 0.7);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 500;
}

.overview-metric .metric-value {
    font-size: 0.875rem;
    color: #ffffff;
    font-weight: 600;
}

/* === CONTENT SECTIONS === */
.content-sections {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
}

/* === GRID LAYOUT SYSTEM === */
.insights-grid-container {
    flex: 1;
    width: 100%;
    min-height: 0;
    /* Allow container to grow with content */
    height: auto;
}

.insights-grid-layout {
    position: relative;
    width: 100%;
    /* Adjust for sidebar constraints */
    min-height: 600px;
    height: auto;
}

.insights-grid-item {
    position: relative;
    background: transparent;
    border-radius: 12px;
    overflow: hidden;
}

.grid-card {
    height: 100%;
    background: rgba(15, 15, 17, 0.4);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(156, 163, 175, 0.22); /* subtle gray border */
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.05) inset,
                0 8px 24px rgba(0, 0, 0, 0.25);
}

.grid-card-header {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid rgba(156, 163, 175, 0.18); /* match gray tone */
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
}

.grid-card-header h3 {
    font-size: 0.875rem;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    letter-spacing: -0.025em;
}

.grid-card-controls {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

.grid-card:hover .grid-card-controls {
    opacity: 1;
}

.grid-drag-handle {
    background: none;
    border: none;
    color: rgba(156, 163, 175, 0.7);
    cursor: move;
    padding: 0.25rem;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.grid-drag-handle:hover {
    color: rgba(156, 163, 175, 1);
    background: rgba(156, 163, 175, 0.1);
}

.grid-card-content {
    flex: 1;
    padding: 0 1rem 1rem; /* remove gap under header */
    overflow-y: auto; /* Keep inner component scrollbars */
    overflow-x: hidden; /* Hide horizontal overflow */
    min-height: 150px; /* Minimum height for content */
    max-height: 100%; /* Fill available space in grid cell */
    
    /* Show native scrollbar inside components */
    scrollbar-width: auto;
    -ms-overflow-style: auto;
    /* Clear separation from header */
    background: rgba(255, 255, 255, 0.015);
    border-top: 1px solid rgba(156, 163, 175, 0.12);
}

/* Custom sidebar scrollbar (visible, mouse-draggable) */
.insights-custom-scrollbar {
    position: absolute;
    top: 0;
    right: 2px;
    width: 8px;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    pointer-events: none; /* allow clicks to pass except on thumb */
}

.insights-custom-thumb {
    width: 100%;
    border-radius: 9999px;
    background: linear-gradient(180deg, rgba(156,163,175,0.35), rgba(156,163,175,0.15));
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: 0 0 0 1px rgba(0,0,0,0.2) inset;
    pointer-events: auto; /* capture drag */
    cursor: grab;
    transition: background 0.2s ease, opacity 0.2s ease;
}

.insights-custom-thumb:active {
    cursor: grabbing;
    background: linear-gradient(180deg, rgba(229,231,235,0.5), rgba(156,163,175,0.35));
}

/* Ensure no extra margin at the very top of card content */
.grid-card-content > *:first-child {
    margin-top: 0 !important;
}

.grid-card-content::-webkit-scrollbar { width: 6px; height: 6px; }

.grid-card-content::-webkit-scrollbar-track {
    background: transparent;
}

.grid-card-content::-webkit-scrollbar-thumb {
    background-color: rgba(75, 85, 99, 0.3);
    border-radius: 3px;
}

.grid-card-content::-webkit-scrollbar-thumb:hover {
    background-color: rgba(75, 85, 99, 0.6);
}

/* Grid layout responsive behavior */
.react-grid-layout {
    position: relative;
}

.react-grid-item {
    transition: all 200ms ease;
    transition-property: left, top;
}

.react-grid-item.cssTransforms {
    transition-property: transform;
}

.react-grid-item > .react-resizable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
    right: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: bottom right;
    padding: 0 3px 3px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: se-resize;
    opacity: 0.4;
    transition: opacity 0.2s ease;
}

.react-grid-item:hover > .react-resizable-handle {
    opacity: 0.8;
}

.react-grid-item > .react-resizable-handle::after {
    content: "";
    position: absolute;
    right: 3px;
    bottom: 3px;
    width: 5px;
    height: 5px;
    border-right: 2px solid rgba(255, 255, 255, 0.4);
    border-bottom: 2px solid rgba(255, 255, 255, 0.4);
}

.react-grid-item.react-grid-placeholder {
    background: rgba(34, 197, 94, 0.18);
    border: 1px dashed rgba(34, 197, 94, 0.45);
    opacity: 0.8;
    transition-duration: 100ms;
    z-index: 2;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 12px;
}

.content-card {
    background: rgba(15, 15, 17, 0.4);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(75, 85, 99, 0.15);
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 320px;
}

.content-card.full-width-card {
    grid-column: 1 / -1;
    min-height: 420px;
}

.card-header {
    padding: 1.25rem 1.5rem 1rem;
    border-bottom: 1px solid rgba(75, 85, 99, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card-header h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    letter-spacing: -0.025em;
}

/* Shimmer animation for loading states */
@keyframes shimmer {
    0% { 
        transform: translateX(-100%); 
    }
    100% { 
        transform: translateX(100%); 
    }
}

.chart-error-indicator {
    color: #ef4444;
    font-size: 1.2rem;
    font-weight: bold;
}

.loading-spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.card-content {
    padding: 1.5rem;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    
    /* Show native scrollbar inside components */
    scrollbar-width: auto;
    -ms-overflow-style: auto;
}

.card-content::-webkit-scrollbar { width: 6px; height: 6px; }

/* Hide scrollbar specifically for the overview description scroller */
/* Ensure description scroller uses native scrollbar */
.ov-desc-scroll { scrollbar-width: auto; -ms-overflow-style: auto; }
.ov-desc-scroll::-webkit-scrollbar { width: 6px; height: 6px; }

.card-content::-webkit-scrollbar-track {
    background: transparent;
}

.card-content::-webkit-scrollbar-thumb {
    background-color: rgba(75, 85, 99, 0.3);
    border-radius: 3px;
}

.card-content::-webkit-scrollbar-thumb:hover {
    background-color: rgba(75, 85, 99, 0.6);
}

/* Loading spinner */
.loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(156, 163, 175, 0.2);
    border-top: 2px solid rgba(34, 197, 94, 0.9);
    border-radius: 50%;
    animation: insights-spin 1s linear infinite;
}

@keyframes insights-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* === RELATED SECTION === */
.related-group {
    margin-bottom: 1rem;
}

.related-group:last-child {
    margin-bottom: 0;
}

.related-group h4 {
    font-size: 0.875rem;
    font-weight: 600;
    color: rgba(209, 213, 219, 0.9);
    margin: 0 0 0.5rem;
    letter-spacing: -0.025em;
}

.related-items {
    display: flex;
    flex-wrap: wrap;
    gap: 0.375rem;
}

.related-item {
    background: rgba(75, 85, 99, 0.2);
    border: 1px solid rgba(75, 85, 99, 0.3);
    border-radius: 9999px;
    padding: 0.4rem 0.6rem;
    font-size: 0.7rem;
    color: rgba(209, 213, 219, 0.9);
    transition: all 0.2s ease;
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.25rem;
    position: relative;
    min-height: 32px;
    box-sizing: border-box;
    width: auto;
}

.related-item:hover {
    border-color: rgba(255, 255, 255, 0.28);
    transform: none;
}

.related-item.selected {
    background: rgba(16, 185, 129, 0.15);
    border-color: rgba(16, 185, 129, 0.3);
    color: #ffffff;
}

/* Consistent styling for both keywords and companies */
.related-item .item-label {
    font-weight: 600;
    color: #ffffff;
    font-size: 0.7rem;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1 auto;
}

.add-remove-icon {
    margin-left: 0.375rem;
    font-size: 0.8rem;
    font-weight: bold;
    color: rgba(156, 163, 175, 0.9);
    transition: color 0.2s ease;
    flex-shrink: 0;
}

.related-item.selected .add-remove-icon {
    color: rgba(16, 185, 129, 0.9);
}

.related-item:hover .add-remove-icon {
    color: rgba(34, 197, 94, 0.9);
}

/* === SENTIMENT SECTION === */
.sentiment-item-container {
    padding: 1rem;
    background: rgba(75, 85, 99, 0.1);
    border: 1px solid rgba(75, 85, 99, 0.2);
    border-radius: 8px;
    margin-bottom: 1rem;
    transition: all 0.2s ease;
}

.sentiment-item-container:hover {
    background: rgba(75, 85, 99, 0.15);
    border-color: rgba(75, 85, 99, 0.3);
}

.sentiment-item-container:last-child {
    margin-bottom: 0;
}

/* === NEWS SECTION === */
.news-items {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-top: 1rem; /* match bottom padding feel */
}

.news-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.news-card {
    background: linear-gradient(180deg, rgba(20,20,24,0.8), rgba(20,20,24,0.6));
    border: 1px solid rgba(156, 163, 175, 0.18);
    border-radius: 10px;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    text-decoration: none;
    position: relative;
    transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
}

.news-card:hover {
    border-color: rgba(255, 255, 255, 0.28);
    background: linear-gradient(180deg, rgba(22,22,26,0.9), rgba(22,22,26,0.7));
}

.news-content {
    flex: 1;
    min-width: 0;
}

.news-title {
    font-size: 0.85rem;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.35;
    margin: 0 0 0.35rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.news-summary {
    font-size: 0.72rem;
    color: rgba(209, 213, 219, 0.75);
    line-height: 1.45;
    margin: 0 0 0.5rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.news-meta {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.65rem;
    color: rgba(156, 163, 175, 0.7);
}

.news-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 6px;
    border-radius: 9999px;
    border: 1px solid rgba(156, 163, 175, 0.3);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(229, 231, 235, 0.9);
}

.news-dot { color: rgba(156, 163, 175, 0.6); }

.news-link {
    color: rgba(34, 197, 94, 0.9);
    transition: color 0.2s ease;
    flex-shrink: 0;
}

.news-link:hover {
    color: #22c55e;
}

.news-link svg {
    width: 14px;
    height: 14px;
    stroke-width: 1.5;
}

/* News thumbnail */
.news-thumb {
    display: block;
    width: 88px;
    height: 64px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.news-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.news-chevron {
    margin-left: auto;
    color: rgba(156, 163, 175, 0.5);
    transition: transform 0.2s ease, color 0.2s ease;
}

.news-chevron svg {
    width: 18px;
    height: 18px;
    stroke-width: 1.5;
}

.news-card:hover .news-chevron {
    transform: translateX(2px);
    color: rgba(229, 231, 235, 0.8);
}

/* === ESTIMATES SECTION === */
.estimates-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.estimate-group { margin-top: 12px; }
.estimate-section-header {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.95);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 12px;
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 6px;
    text-align: center;
}
.estimate-subtitle {
    font-size: 12px;
    color: rgba(156, 163, 175, 0.9);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    font-weight: 600;
    padding: 4px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    margin-bottom: 4px;
}
.estimate-item { padding: 6px 0; border-bottom: 1px dashed rgba(255, 255, 255, 0.08); }
.estimate-item:last-child { border-bottom: none; }
.estimate-label { font-size: 12px; color: rgba(156, 163, 175, 0.85); font-weight: 500; }
.estimate-value { font-size: 12px; color: #fff; font-weight: 600; font-variant-numeric: tabular-nums; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

.estimate-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid rgba(75, 85, 99, 0.1);
}

.estimate-item:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.estimate-label {
    font-size: 0.875rem;
    color: rgba(156, 163, 175, 0.8);
    font-weight: 500;
}

.estimate-value {
    font-size: 0.875rem;
    color: #ffffff;
    font-weight: 600;
}

.estimate-value.rating {
    padding: 0.25rem 0.5rem;
    background: rgba(16, 185, 129, 0.15);
    color: #10b981;
    border-radius: 6px;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.estimate-value.positive {
    color: #10b981;
}

.estimate-value.negative {
    color: #ef4444;
}

/* === EMPTY STATES === */
.empty-state,
.error-state {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    text-align: center;
}

.empty-state p,
.error-state p {
    color: rgba(156, 163, 175, 0.6);
    font-size: 0.875rem;
    margin: 0;
}

.error-state p {
    color: rgba(239, 68, 68, 0.7);
}

/* === RESPONSIVE DESIGN === */
@media (max-width: 1200px) {
    .insights-sidebar-redesigned {
        width: 350px;
    }
    
    .content-sections {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }
    
    .content-card {
        min-height: 280px;
    }
    
    .insights-content {
        padding: 0.75rem;
        gap: 0.75rem;
    }
    
    .insights-grid-layout {
        min-height: 500px;
    }
}

@media (max-width: 768px) {
    .insights-sidebar-redesigned {
        width: 100vw;
        height: 100dvh; /* Use dynamic viewport height on mobile */
        border-left: none;
        border-top: 1px solid rgba(75, 85, 99, 0.2);
    }
    
    .sidebar-backdrop {
        display: block;
    }
    
    .sidebar-toggle {
        top: 10px;
        right: 10px;
        width: 40px;
        height: 40px;
    }
    
    .sidebar-toggle svg {
        width: 18px;
        height: 18px;
    }
    
    .hero-card {
        padding: 0.75rem;
    }
    
    .hero-metrics {
        justify-content: center;
    }
    
    .overview-section {
        padding: 0.75rem;
    }
    
    .overview-metrics {
        justify-content: center;
        text-align: center;
    }
    
    .content-card {
        min-height: 220px;
    }
    
    .card-header,
    .card-content {
        padding: 0.75rem;
    }
    
    .related-items {
        justify-content: center;
    }
    
    .insights-content {
        padding: 0.5rem;
        gap: 0.5rem;
    }
    
    .insights-grid-layout {
        min-height: 400px;
    }
    
    /* Enhanced Overview Responsive */
    .overview-metrics-grid {
        grid-template-columns: 1fr;
        gap: 0.375rem;
    }
    
    .overview-metric-card {
        padding: 0.5rem;
    }
    
    .overview-company-name {
        font-size: 1rem;
    }
} `, "",{"version":3,"sources":["webpack://./src/shared/styles/insights-sidebar.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,wDAAwD;AACxD;;IAEI,kBAAkB;AACtB;;AAEA,oCAAoC;AACpC;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,mCAAmC;IACnC,2BAA2B;IAC3B,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,2BAA2B;IAC3B,sCAAsC;IACtC,0CAA0C;AAC9C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,mCAAmC;IACnC,2BAA2B;IAC3B,uCAAuC;IACvC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8CAA8C;IAC9C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,mDAAmD;IACnD,aAAa,EAAE,uCAAuC;AAC1D;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,cAAc;IACd,aAAa,EAAE,iCAAiC;IAChD,gBAAgB;IAChB,kBAAkB;IAClB,eAAe,EAAE,qDAAqD;IACtE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAE,uDAAuD;IACrE,uBAAuB;IACvB,iCAAiC;IACjC,0CAA0C;IAC1C,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB,EAAE,qCAAqC;AAC7D;;AAEA,uCAAuC,UAAU,EAAE,WAAW,EAAE;;AAEhE;IACI,uBAAuB;AAC3B;;AAEA,6CAA6C,uCAAuC,EAAE,kBAAkB,EAAE;;AAE1G;IACI,uCAAuC;AAC3C;;;;AAIA,sBAAsB;AACtB;IACI;;mCAE+B;IAC/B,mCAAmC;IACnC,2BAA2B;IAC3B,uCAAuC;IACvC,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX;;;oBAGgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;;;AAIA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,mCAAmC;AACvC;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;AACb;;AAEA,6BAA6B;AAC7B;IACI,iCAAiC;IACjC,mCAAmC;IACnC,2BAA2B;IAC3B,wCAAwC;IACxC,mBAAmB;IACnB,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;IACI,iCAAiC;IACjC,kCAAkC;IAClC,0BAA0B;IAC1B,wCAAwC;IACxC,kBAAkB;IAClB,wBAAwB;IACxB,SAAS,EAAE,kEAAkE;IAC7E;;;+CAG2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,6FAA6F;IAC7F,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA,yCAAyC;AACzC;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;;;AAIA,2BAA2B;AAC3B;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;AACnB;;AAEA,qCAAqC;AACrC;IACI,iCAAiC;IACjC,kCAAkC;IAClC,0BAA0B;IAC1B,uCAAuC;IACvC,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA,6BAA6B;AAC7B;IACI,qBAAqB;IACrB,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,2DAA2D;IAC3D,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,yBAAyB;IACzB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,sBAAsB;AAC1B;;AAEA,wBAAwB;AACxB;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;IAC/B,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,0BAA0B;IAC1B,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI,OAAO;IACP,WAAW;IACX,aAAa;IACb,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mCAAmC;IACnC,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,mCAAmC;IACnC,2BAA2B;IAC3B,2CAA2C,EAAE,uBAAuB;IACpE,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB;8CAC0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,kDAAkD,EAAE,oBAAoB;IACxE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,yFAAyF;AAC7F;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,OAAO;IACP,oBAAoB,EAAE,4BAA4B;IAClD,gBAAgB,EAAE,oCAAoC;IACtD,kBAAkB,EAAE,6BAA6B;IACjD,iBAAiB,EAAE,+BAA+B;IAClD,gBAAgB,EAAE,sCAAsC;;IAExD,4CAA4C;IAC5C,qBAAqB;IACrB,wBAAwB;IACxB,iCAAiC;IACjC,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA,wDAAwD;AACxD;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB,EAAE,yCAAyC;AACnE;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,mFAAmF;IACnF,2CAA2C;IAC3C,2CAA2C;IAC3C,oBAAoB,EAAE,iBAAiB;IACvC,YAAY;IACZ,mDAAmD;AACvD;;AAEA;IACI,gBAAgB;IAChB,kFAAkF;AACtF;;AAEA,2DAA2D;AAC3D;IACI,wBAAwB;AAC5B;;AAEA,wCAAwC,UAAU,EAAE,WAAW,EAAE;;AAEjE;IACI,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,mDAAyd;IACzd,iCAAiC;IACjC,oBAAoB;IACpB,4BAA4B;IAC5B,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,WAAW;IACX,gDAAgD;IAChD,iDAAiD;AACrD;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;IAC1C,YAAY;IACZ,0BAA0B;IAC1B,UAAU;IACV,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,2BAA2B;IAC3B,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,8CAA8C;IAC9C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,wBAAwB;AAC5B;;AAEA,yCAAyC;AACzC;IACI;QACI,4BAA4B;IAChC;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;;IAEb,4CAA4C;IAC5C,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA,mCAAmC,UAAU,EAAE,WAAW,EAAE;;AAE5D,sEAAsE;AACtE,sDAAsD;AACtD,kBAAkB,qBAAqB,EAAE,wBAAwB,EAAE;AACnE,qCAAqC,UAAU,EAAE,WAAW,EAAE;;AAE9D;IACI,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,4CAA4C;IAC5C,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,+BAA+B;IAC/B,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,cAAc;AAClB;;AAEA,uDAAuD;AACvD;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,iCAAiC;IACjC,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB,EAAE,8BAA8B;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,2EAA2E;IAC3E,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,6EAA6E;AACjF;;AAEA;IACI,uCAAuC;IACvC,2EAA2E;AAC/E;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,0CAA0C;IAC1C,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA,YAAY,+BAA+B,EAAE;;AAE7C;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA,kBAAkB,gBAAgB,EAAE;AACpC;IACI,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,+BAA+B;IAC/B,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,kDAAkD;IAClD,kBAAkB;AACtB;AACA,iBAAiB,cAAc,EAAE,mDAAmD,EAAE;AACtF,4BAA4B,mBAAmB,EAAE;AACjD,kBAAkB,eAAe,EAAE,gCAAgC,EAAE,gBAAgB,EAAE;AACvF,kBAAkB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,kCAAkC,EAAE,+GAA+G,EAAE;;AAEvN;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,+BAA+B;IAC/B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,6BAA6B;AACjC;;AAEA,8BAA8B;AAC9B;IACI;QACI,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,cAAc,EAAE,0CAA0C;QAC1D,iBAAiB;QACjB,2CAA2C;IAC/C;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA,iCAAiC;IACjC;QACI,0BAA0B;QAC1B,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* === INSIGHTS SIDEBAR STYLES === */\n\n/* Remove page scrollbar when insights sidebar is open */\nhtml:has(.insights-sidebar-redesigned.open),\nbody:has(.insights-sidebar-redesigned.open) {\n    overflow-y: hidden;\n}\n\n/* Main container - SIDEBAR LAYOUT */\n.insights-sidebar-redesigned {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 400px;\n    height: 100vh;\n    background: rgba(10, 10, 12, 0.95);\n    -webkit-backdrop-filter: blur(20px);\n    backdrop-filter: blur(20px);\n    border-left: 1px solid rgba(75, 85, 99, 0.2);\n    display: flex;\n    flex-direction: column;\n    z-index: 100002;\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);\n}\n\n.insights-sidebar-redesigned.open {\n    transform: translateX(0);\n}\n\n/* Stacked mode styles */\n.insights-sidebar-redesigned.stacked {\n    position: static;\n    width: 100%;\n    height: auto;\n    transform: none;\n    background: transparent;\n    -webkit-backdrop-filter: none;\n    backdrop-filter: none;\n    border: none;\n    box-shadow: none;\n    z-index: auto;\n}\n\n.insights-sidebar-redesigned.stacked .insights-content {\n    padding: 0.5rem 0;\n}\n\n.insights-sidebar-redesigned.stacked .stacked-header {\n    padding: 1rem 1rem 0 1rem;\n    border-bottom: 1px solid rgba(75, 85, 99, 0.1);\n    margin-bottom: 0.25rem;\n}\n\n/* Sidebar toggle button */\n.sidebar-toggle {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    width: 48px;\n    height: 48px;\n    background: rgba(15, 15, 17, 0.9);\n    -webkit-backdrop-filter: blur(12px);\n    backdrop-filter: blur(12px);\n    border: 1px solid rgba(75, 85, 99, 0.3);\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 100003;\n    transition: all 0.2s ease;\n    color: rgba(255, 255, 255, 0.8);\n}\n\n.sidebar-toggle:hover {\n    background: rgba(15, 15, 17, 1);\n    border-color: rgba(34, 197, 94, 0.4);\n    color: rgba(34, 197, 94, 0.9);\n    transform: scale(1.05);\n}\n\n.sidebar-toggle svg {\n    width: 20px;\n    height: 20px;\n    stroke-width: 2;\n}\n\n/* Sidebar header */\n.sidebar-header {\n    padding: 1rem;\n    border-bottom: 1px solid rgba(75, 85, 99, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: rgba(15, 15, 17, 0.5);\n    flex-shrink: 0;\n}\n\n.sidebar-title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0;\n    letter-spacing: -0.025em;\n}\n\n.sidebar-close {\n    background: none;\n    border: none;\n    color: rgba(156, 163, 175, 0.7);\n    cursor: pointer;\n    padding: 0.25rem;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.sidebar-close:hover {\n    color: rgba(156, 163, 175, 1);\n    background: rgba(156, 163, 175, 0.1);\n}\n\n.sidebar-close svg {\n    width: 16px;\n    height: 16px;\n    stroke-width: 2;\n}\n\n/* Backdrop overlay for mobile */\n.sidebar-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 100001;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n    display: none; /* Hidden by default, shown on mobile */\n}\n\n.sidebar-backdrop.visible {\n    opacity: 1;\n    visibility: visible;\n}\n\n/* Scrollable content area */\n.insights-content {\n    flex: 1 1 auto;\n    min-height: 0; /* critical to prevent clipping */\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 0.5rem; /* Reduced from 0.75rem to minimize overall spacing */\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem; /* Reduced from 0.75rem to bring sections much closer */\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    /* Show native scrollbar for the sidebar */\n    scrollbar-width: auto;\n    -ms-overflow-style: auto;\n    position: relative; /* for custom scrollbar positioning */\n}\n\n.insights-content::-webkit-scrollbar { width: 8px; height: 8px; }\n\n.insights-content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.insights-content::-webkit-scrollbar-thumb { background-color: rgba(75, 85, 99, 0.4); border-radius: 3px; }\n\n.insights-content::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(75, 85, 99, 0.7);\n}\n\n\n\n/* === HERO CARD === */\n.hero-card {\n    background: linear-gradient(135deg, \n        rgba(15, 15, 17, 0.95) 0%,\n        rgba(30, 30, 35, 0.8) 100%);\n    -webkit-backdrop-filter: blur(20px);\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(75, 85, 99, 0.2);\n    border-radius: 12px;\n    padding: 1rem;\n    position: relative;\n    overflow: hidden;\n}\n\n.hero-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background: linear-gradient(90deg, \n        transparent, \n        rgba(34, 197, 94, 0.3), \n        transparent);\n}\n\n.hero-card-empty {\n    text-align: center;\n    padding: 1.5rem 1rem;\n}\n\n.hero-empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.hero-empty-icon {\n    width: 32px;\n    height: 32px;\n    color: rgba(156, 163, 175, 0.6);\n    margin-bottom: 0.25rem;\n}\n\n.hero-empty-icon svg {\n    width: 100%;\n    height: 100%;\n    stroke-width: 1;\n}\n\n.hero-empty-state h3 {\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 1.125rem;\n    font-weight: 600;\n    margin: 0;\n}\n\n.hero-empty-state p {\n    color: rgba(156, 163, 175, 0.7);\n    font-size: 0.875rem;\n    line-height: 1.5;\n    margin: 0;\n    max-width: 280px;\n}\n\n/* Company hero card - Compact centered design */\n.hero-card-company .hero-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 1rem;\n}\n\n\n\n.hero-logo {\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.05);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.hero-logo img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.hero-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 0.5rem;\n}\n\n.hero-symbol-row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n}\n\n.hero-symbol {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #ffffff;\n    letter-spacing: -0.025em;\n    margin: 0;\n}\n\n.hero-name {\n    font-size: 0.9rem;\n    color: rgba(156, 163, 175, 0.9);\n    font-weight: 500;\n    margin: 0;\n}\n\n.hero-metrics {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 0.5rem;\n}\n\n.hero-metric-primary {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n}\n\n.metric-value {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #ffffff;\n}\n\n.metric-change {\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 0.375rem 0.75rem;\n    border-radius: 8px;\n}\n\n.metric-change.positive {\n    color: #10b981;\n    background: rgba(16, 185, 129, 0.15);\n}\n\n.metric-change.negative {\n    color: #ef4444;\n    background: rgba(239, 68, 68, 0.15);\n}\n\n/* Keyword hero card - Compact centered design */\n.hero-card-keyword .hero-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 1rem;\n}\n\n.hero-keyword-icon {\n    width: 40px;\n    height: 40px;\n    color: rgba(34, 197, 94, 0.85);\n    flex-shrink: 0;\n}\n\n.hero-keyword-icon svg {\n    width: 100%;\n    height: 100%;\n    stroke-width: 1.5;\n}\n\n.hero-keyword-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 0.5rem;\n}\n\n.hero-keyword-name {\n    font-size: 1.75rem;\n    font-weight: 600;\n    color: #ffffff;\n    letter-spacing: -0.025em;\n    margin: 0;\n}\n\n.hero-keyword-type {\n    font-size: 0.875rem;\n    color: rgba(156, 163, 175, 0.7);\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    font-weight: 500;\n    margin: 0;\n}\n\n/* === COMPANY OVERVIEW === */\n.overview-section {\n    background: rgba(15, 15, 17, 0.4);\n    -webkit-backdrop-filter: blur(12px);\n    backdrop-filter: blur(12px);\n    border: 1px solid rgba(75, 85, 99, 0.15);\n    border-radius: 12px;\n    padding: 1.5rem;\n}\n\n/* === COMPACT HERO CARD === */\n.hero-card-compact {\n    background: rgba(15, 15, 17, 0.4);\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    border: 2px solid rgba(34, 197, 94, 0.3);\n    border-radius: 8px;\n    padding: 0.375rem 0.5rem;\n    margin: 0; /* Removed bottom margin since overview section margins are gone */\n    box-shadow: \n        0 4px 12px rgba(0, 0, 0, 0.15),\n        0 0 0 1px rgba(34, 197, 94, 0.1),\n        inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    position: relative;\n}\n\n.hero-card-compact::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(135deg, rgba(34, 197, 94, 0.02) 0%, rgba(34, 197, 94, 0.05) 100%);\n    border-radius: 6px;\n    pointer-events: none;\n}\n\n.hero-content-horizontal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    position: relative;\n    z-index: 1;\n}\n\n/* For keyword cards, center everything */\n.hero-card-keyword-compact .hero-content-horizontal {\n    flex-direction: row;\n    text-align: center;\n}\n\n.hero-logo-compact {\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(255, 255, 255, 0.08);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.hero-logo-compact img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.hero-info-compact {\n    flex: 0 1 auto;\n    min-width: 0;\n    text-align: center;\n}\n\n.hero-symbol-compact {\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.98);\n    line-height: 1.1;\n    letter-spacing: 0.025em;\n}\n\n.hero-name-compact {\n    font-size: 0.65rem;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.7);\n    line-height: 1.2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 120px;\n}\n\n\n\n/* Keyword compact styles */\n.hero-keyword-icon-compact {\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: rgba(34, 197, 94, 0.8);\n    background: rgba(34, 197, 94, 0.1);\n    border: 1px solid rgba(34, 197, 94, 0.2);\n    border-radius: 4px;\n}\n\n.hero-keyword-icon-compact svg {\n    width: 12px;\n    height: 12px;\n    stroke-width: 2.5;\n}\n\n.hero-keyword-info-compact {\n    flex: 1;\n    min-width: 0;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.hero-keyword-name-compact {\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.98);\n    line-height: 1.1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    letter-spacing: 0.025em;\n}\n\n.hero-keyword-type-compact {\n    font-size: 0.65rem;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.7);\n    line-height: 1.2;\n    margin-top: 1px;\n}\n\n/* === COMPACT COMPANY OVERVIEW === */\n.overview-section-compact {\n    background: rgba(15, 15, 17, 0.3);\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    border: 1px solid rgba(75, 85, 99, 0.1);\n    border-radius: 8px;\n}\n\n\n.company-name-compact {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0 0 0.25rem 0;\n    line-height: 1.2;\n}\n\n.exchange-info-compact {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.75rem;\n    color: rgba(156, 163, 175, 0.8);\n}\n\n.symbol-compact {\n    font-weight: 500;\n    color: rgba(34, 197, 94, 0.9);\n}\n\n.exchange-compact {\n    color: rgba(156, 163, 175, 0.6);\n}\n\n.metrics-grid-compact {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.375rem;\n    margin-bottom: 0.5rem;\n}\n\n.metric-item-compact {\n    display: flex;\n    flex-direction: column;\n    gap: 0.125rem;\n}\n\n.metric-label-compact {\n    font-size: 0.625rem;\n    color: rgba(156, 163, 175, 0.6);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    font-weight: 500;\n}\n\n.metric-value-compact {\n    font-size: 0.75rem;\n    color: #ffffff;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.description-compact {\n    border-top: 1px solid rgba(75, 85, 99, 0.15);\n    padding-top: 0.5rem;\n}\n\n.description-compact p {\n    font-size: 0.75rem;\n    color: rgba(209, 213, 219, 0.8);\n    line-height: 1.4;\n    margin: 0 0 0.375rem 0;\n}\n\n.website-link-compact {\n    display: inline-flex;\n    align-items: center;\n    font-size: 0.7rem;\n    color: rgba(96, 165, 250, 0.8);\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.2s ease;\n}\n\n.website-link-compact:hover {\n    color: rgba(96, 165, 250, 1);\n}\n\n/* Enhanced Overview Header */\n.overview-header {\n    margin-bottom: 1.5rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid rgba(75, 85, 99, 0.2);\n}\n\n.overview-title-row {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.overview-company-name {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0;\n    line-height: 1.3;\n}\n\n.overview-exchange-info {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.875rem;\n    color: rgba(156, 163, 175, 0.8);\n}\n\n.overview-symbol {\n    font-weight: 600;\n    color: rgba(96, 165, 250, 0.9);\n}\n\n.overview-exchange {\n    color: rgba(156, 163, 175, 0.7);\n}\n\n/* Enhanced Metrics Grid */\n.overview-metrics-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n}\n\n.overview-metric-card {\n    background: rgba(30, 30, 35, 0.5);\n    border: 1px solid rgba(75, 85, 99, 0.2);\n    border-radius: 8px;\n    padding: 0.875rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.375rem;\n    transition: all 0.2s ease;\n}\n\n.overview-metric-card:hover {\n    background: rgba(30, 30, 35, 0.7);\n    border-color: rgba(75, 85, 99, 0.3);\n    transform: translateY(-1px);\n}\n\n.overview-metric-card .metric-label {\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: rgba(156, 163, 175, 0.8);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin: 0;\n}\n\n.overview-metric-card .metric-value {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0;\n    word-break: break-word;\n}\n\n/* Company Description */\n.overview-description {\n    margin-bottom: 1.5rem;\n}\n\n.overview-description h3 {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0 0 0.75rem 0;\n}\n\n.overview-description p {\n    font-size: 0.875rem;\n    line-height: 1.6;\n    color: rgba(209, 213, 219, 0.9);\n    margin: 0;\n}\n\n/* Website Link */\n.overview-website {\n    margin-top: 1rem;\n}\n\n.website-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    background: rgba(34, 197, 94, 0.12);\n    border: 1px solid rgba(34, 197, 94, 0.25);\n    border-radius: 8px;\n    color: rgba(34, 197, 94, 0.95);\n    text-decoration: none;\n    font-size: 0.875rem;\n    font-weight: 500;\n    transition: all 0.2s ease;\n}\n\n.website-link:hover {\n    background: rgba(34, 197, 94, 0.18);\n    border-color: rgba(34, 197, 94, 0.35);\n    color: #22c55e;\n    transform: translateY(-1px);\n}\n\n.website-link svg {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n}\n\n.overview-content {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.overview-description p {\n    color: rgba(209, 213, 219, 0.9);\n    font-size: 0.875rem;\n    line-height: 1.6;\n    margin: 0;\n}\n\n.overview-metrics {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1.5rem;\n}\n\n.overview-metric {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.overview-metric .metric-label {\n    font-size: 0.75rem;\n    color: rgba(156, 163, 175, 0.7);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    font-weight: 500;\n}\n\n.overview-metric .metric-value {\n    font-size: 0.875rem;\n    color: #ffffff;\n    font-weight: 600;\n}\n\n/* === CONTENT SECTIONS === */\n.content-sections {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n}\n\n/* === GRID LAYOUT SYSTEM === */\n.insights-grid-container {\n    flex: 1;\n    width: 100%;\n    min-height: 0;\n    /* Allow container to grow with content */\n    height: auto;\n}\n\n.insights-grid-layout {\n    position: relative;\n    width: 100%;\n    /* Adjust for sidebar constraints */\n    min-height: 600px;\n    height: auto;\n}\n\n.insights-grid-item {\n    position: relative;\n    background: transparent;\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.grid-card {\n    height: 100%;\n    background: rgba(15, 15, 17, 0.4);\n    -webkit-backdrop-filter: blur(12px);\n    backdrop-filter: blur(12px);\n    border: 1px solid rgba(156, 163, 175, 0.22); /* subtle gray border */\n    border-radius: 12px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.05) inset,\n                0 8px 24px rgba(0, 0, 0, 0.25);\n}\n\n.grid-card-header {\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid rgba(156, 163, 175, 0.18); /* match gray tone */\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));\n}\n\n.grid-card-header h3 {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0;\n    letter-spacing: -0.025em;\n}\n\n.grid-card-controls {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    opacity: 0.6;\n    transition: opacity 0.2s ease;\n}\n\n.grid-card:hover .grid-card-controls {\n    opacity: 1;\n}\n\n.grid-drag-handle {\n    background: none;\n    border: none;\n    color: rgba(156, 163, 175, 0.7);\n    cursor: move;\n    padding: 0.25rem;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.grid-drag-handle:hover {\n    color: rgba(156, 163, 175, 1);\n    background: rgba(156, 163, 175, 0.1);\n}\n\n.grid-card-content {\n    flex: 1;\n    padding: 0 1rem 1rem; /* remove gap under header */\n    overflow-y: auto; /* Keep inner component scrollbars */\n    overflow-x: hidden; /* Hide horizontal overflow */\n    min-height: 150px; /* Minimum height for content */\n    max-height: 100%; /* Fill available space in grid cell */\n    \n    /* Show native scrollbar inside components */\n    scrollbar-width: auto;\n    -ms-overflow-style: auto;\n    /* Clear separation from header */\n    background: rgba(255, 255, 255, 0.015);\n    border-top: 1px solid rgba(156, 163, 175, 0.12);\n}\n\n/* Custom sidebar scrollbar (visible, mouse-draggable) */\n.insights-custom-scrollbar {\n    position: absolute;\n    top: 0;\n    right: 2px;\n    width: 8px;\n    height: 100%;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    pointer-events: none; /* allow clicks to pass except on thumb */\n}\n\n.insights-custom-thumb {\n    width: 100%;\n    border-radius: 9999px;\n    background: linear-gradient(180deg, rgba(156,163,175,0.35), rgba(156,163,175,0.15));\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    box-shadow: 0 0 0 1px rgba(0,0,0,0.2) inset;\n    pointer-events: auto; /* capture drag */\n    cursor: grab;\n    transition: background 0.2s ease, opacity 0.2s ease;\n}\n\n.insights-custom-thumb:active {\n    cursor: grabbing;\n    background: linear-gradient(180deg, rgba(229,231,235,0.5), rgba(156,163,175,0.35));\n}\n\n/* Ensure no extra margin at the very top of card content */\n.grid-card-content > *:first-child {\n    margin-top: 0 !important;\n}\n\n.grid-card-content::-webkit-scrollbar { width: 6px; height: 6px; }\n\n.grid-card-content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.grid-card-content::-webkit-scrollbar-thumb {\n    background-color: rgba(75, 85, 99, 0.3);\n    border-radius: 3px;\n}\n\n.grid-card-content::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(75, 85, 99, 0.6);\n}\n\n/* Grid layout responsive behavior */\n.react-grid-layout {\n    position: relative;\n}\n\n.react-grid-item {\n    transition: all 200ms ease;\n    transition-property: left, top;\n}\n\n.react-grid-item.cssTransforms {\n    transition-property: transform;\n}\n\n.react-grid-item > .react-resizable-handle {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    bottom: 0;\n    right: 0;\n    background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNiA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZG90cyBmaWxsPSIjOTk5IiBvcGFjaXR5PSIwLjYiPgo8Y2lyY2xlIGN4PSI1IiBjeT0iNSIgcj0iMSIvPgo8Y2lyY2xlIGN4PSI1IiBjeT0iMyIgcj0iMSIvPgo8Y2lyY2xlIGN4PSI1IiBjeT0iMSIgcj0iMSIvPgo8Y2lyY2xlIGN4PSIzIiBjeT0iNSIgcj0iMSIvPgo8Y2lyY2xlIGN4PSIzIiBjeT0iMyIgcj0iMSIvPgo8Y2lyY2xlIGN4PSIxIiBjeT0iNSIgcj0iMSIvPgo8L2RvdHM+Cjwvc3ZnPgo=');\n    background-position: bottom right;\n    padding: 0 3px 3px 0;\n    background-repeat: no-repeat;\n    background-origin: content-box;\n    box-sizing: border-box;\n    cursor: se-resize;\n    opacity: 0.4;\n    transition: opacity 0.2s ease;\n}\n\n.react-grid-item:hover > .react-resizable-handle {\n    opacity: 0.8;\n}\n\n.react-grid-item > .react-resizable-handle::after {\n    content: \"\";\n    position: absolute;\n    right: 3px;\n    bottom: 3px;\n    width: 5px;\n    height: 5px;\n    border-right: 2px solid rgba(255, 255, 255, 0.4);\n    border-bottom: 2px solid rgba(255, 255, 255, 0.4);\n}\n\n.react-grid-item.react-grid-placeholder {\n    background: rgba(34, 197, 94, 0.18);\n    border: 1px dashed rgba(34, 197, 94, 0.45);\n    opacity: 0.8;\n    transition-duration: 100ms;\n    z-index: 2;\n    -webkit-user-select: none;\n    user-select: none;\n    border-radius: 12px;\n}\n\n.content-card {\n    background: rgba(15, 15, 17, 0.4);\n    -webkit-backdrop-filter: blur(12px);\n    backdrop-filter: blur(12px);\n    border: 1px solid rgba(75, 85, 99, 0.15);\n    border-radius: 12px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    min-height: 320px;\n}\n\n.content-card.full-width-card {\n    grid-column: 1 / -1;\n    min-height: 420px;\n}\n\n.card-header {\n    padding: 1.25rem 1.5rem 1rem;\n    border-bottom: 1px solid rgba(75, 85, 99, 0.1);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.card-header h3 {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0;\n    letter-spacing: -0.025em;\n}\n\n/* Shimmer animation for loading states */\n@keyframes shimmer {\n    0% { \n        transform: translateX(-100%); \n    }\n    100% { \n        transform: translateX(100%); \n    }\n}\n\n.chart-error-indicator {\n    color: #ef4444;\n    font-size: 1.2rem;\n    font-weight: bold;\n}\n\n.loading-spinner-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n}\n\n.card-content {\n    padding: 1.5rem;\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    min-height: 0;\n    \n    /* Show native scrollbar inside components */\n    scrollbar-width: auto;\n    -ms-overflow-style: auto;\n}\n\n.card-content::-webkit-scrollbar { width: 6px; height: 6px; }\n\n/* Hide scrollbar specifically for the overview description scroller */\n/* Ensure description scroller uses native scrollbar */\n.ov-desc-scroll { scrollbar-width: auto; -ms-overflow-style: auto; }\n.ov-desc-scroll::-webkit-scrollbar { width: 6px; height: 6px; }\n\n.card-content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.card-content::-webkit-scrollbar-thumb {\n    background-color: rgba(75, 85, 99, 0.3);\n    border-radius: 3px;\n}\n\n.card-content::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(75, 85, 99, 0.6);\n}\n\n/* Loading spinner */\n.loading-spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(156, 163, 175, 0.2);\n    border-top: 2px solid rgba(34, 197, 94, 0.9);\n    border-radius: 50%;\n    animation: insights-spin 1s linear infinite;\n}\n\n@keyframes insights-spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* === RELATED SECTION === */\n.related-group {\n    margin-bottom: 1rem;\n}\n\n.related-group:last-child {\n    margin-bottom: 0;\n}\n\n.related-group h4 {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: rgba(209, 213, 219, 0.9);\n    margin: 0 0 0.5rem;\n    letter-spacing: -0.025em;\n}\n\n.related-items {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.375rem;\n}\n\n.related-item {\n    background: rgba(75, 85, 99, 0.2);\n    border: 1px solid rgba(75, 85, 99, 0.3);\n    border-radius: 9999px;\n    padding: 0.4rem 0.6rem;\n    font-size: 0.7rem;\n    color: rgba(209, 213, 219, 0.9);\n    transition: all 0.2s ease;\n    cursor: pointer;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.25rem;\n    position: relative;\n    min-height: 32px;\n    box-sizing: border-box;\n    width: auto;\n}\n\n.related-item:hover {\n    border-color: rgba(255, 255, 255, 0.28);\n    transform: none;\n}\n\n.related-item.selected {\n    background: rgba(16, 185, 129, 0.15);\n    border-color: rgba(16, 185, 129, 0.3);\n    color: #ffffff;\n}\n\n/* Consistent styling for both keywords and companies */\n.related-item .item-label {\n    font-weight: 600;\n    color: #ffffff;\n    font-size: 0.7rem;\n    line-height: 1.2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1 1 auto;\n}\n\n.add-remove-icon {\n    margin-left: 0.375rem;\n    font-size: 0.8rem;\n    font-weight: bold;\n    color: rgba(156, 163, 175, 0.9);\n    transition: color 0.2s ease;\n    flex-shrink: 0;\n}\n\n.related-item.selected .add-remove-icon {\n    color: rgba(16, 185, 129, 0.9);\n}\n\n.related-item:hover .add-remove-icon {\n    color: rgba(34, 197, 94, 0.9);\n}\n\n/* === SENTIMENT SECTION === */\n.sentiment-item-container {\n    padding: 1rem;\n    background: rgba(75, 85, 99, 0.1);\n    border: 1px solid rgba(75, 85, 99, 0.2);\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    transition: all 0.2s ease;\n}\n\n.sentiment-item-container:hover {\n    background: rgba(75, 85, 99, 0.15);\n    border-color: rgba(75, 85, 99, 0.3);\n}\n\n.sentiment-item-container:last-child {\n    margin-bottom: 0;\n}\n\n/* === NEWS SECTION === */\n.news-items {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding-top: 1rem; /* match bottom padding feel */\n}\n\n.news-item {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.news-card {\n    background: linear-gradient(180deg, rgba(20,20,24,0.8), rgba(20,20,24,0.6));\n    border: 1px solid rgba(156, 163, 175, 0.18);\n    border-radius: 10px;\n    padding: 0.75rem;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    text-decoration: none;\n    position: relative;\n    transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;\n}\n\n.news-card:hover {\n    border-color: rgba(255, 255, 255, 0.28);\n    background: linear-gradient(180deg, rgba(22,22,26,0.9), rgba(22,22,26,0.7));\n}\n\n.news-content {\n    flex: 1;\n    min-width: 0;\n}\n\n.news-title {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #ffffff;\n    line-height: 1.35;\n    margin: 0 0 0.35rem;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.news-summary {\n    font-size: 0.72rem;\n    color: rgba(209, 213, 219, 0.75);\n    line-height: 1.45;\n    margin: 0 0 0.5rem;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.news-meta {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.65rem;\n    color: rgba(156, 163, 175, 0.7);\n}\n\n.news-chip {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 6px;\n    border-radius: 9999px;\n    border: 1px solid rgba(156, 163, 175, 0.3);\n    background: rgba(255, 255, 255, 0.04);\n    color: rgba(229, 231, 235, 0.9);\n}\n\n.news-dot { color: rgba(156, 163, 175, 0.6); }\n\n.news-link {\n    color: rgba(34, 197, 94, 0.9);\n    transition: color 0.2s ease;\n    flex-shrink: 0;\n}\n\n.news-link:hover {\n    color: #22c55e;\n}\n\n.news-link svg {\n    width: 14px;\n    height: 14px;\n    stroke-width: 1.5;\n}\n\n/* News thumbnail */\n.news-thumb {\n    display: block;\n    width: 88px;\n    height: 64px;\n    border-radius: 6px;\n    overflow: hidden;\n    flex-shrink: 0;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.news-thumb img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n\n.news-chevron {\n    margin-left: auto;\n    color: rgba(156, 163, 175, 0.5);\n    transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.news-chevron svg {\n    width: 18px;\n    height: 18px;\n    stroke-width: 1.5;\n}\n\n.news-card:hover .news-chevron {\n    transform: translateX(2px);\n    color: rgba(229, 231, 235, 0.8);\n}\n\n/* === ESTIMATES SECTION === */\n.estimates-content {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n.estimate-group { margin-top: 12px; }\n.estimate-section-header {\n    font-size: 14px;\n    color: rgba(255, 255, 255, 0.95);\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    margin-bottom: 12px;\n    padding: 8px 12px;\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 6px;\n    text-align: center;\n}\n.estimate-subtitle {\n    font-size: 12px;\n    color: rgba(156, 163, 175, 0.9);\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    font-weight: 600;\n    padding: 4px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    margin-bottom: 4px;\n}\n.estimate-item { padding: 6px 0; border-bottom: 1px dashed rgba(255, 255, 255, 0.08); }\n.estimate-item:last-child { border-bottom: none; }\n.estimate-label { font-size: 12px; color: rgba(156, 163, 175, 0.85); font-weight: 500; }\n.estimate-value { font-size: 12px; color: #fff; font-weight: 600; font-variant-numeric: tabular-nums; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; }\n\n.estimate-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 0;\n    border-bottom: 1px solid rgba(75, 85, 99, 0.1);\n}\n\n.estimate-item:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n}\n\n.estimate-label {\n    font-size: 0.875rem;\n    color: rgba(156, 163, 175, 0.8);\n    font-weight: 500;\n}\n\n.estimate-value {\n    font-size: 0.875rem;\n    color: #ffffff;\n    font-weight: 600;\n}\n\n.estimate-value.rating {\n    padding: 0.25rem 0.5rem;\n    background: rgba(16, 185, 129, 0.15);\n    color: #10b981;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.estimate-value.positive {\n    color: #10b981;\n}\n\n.estimate-value.negative {\n    color: #ef4444;\n}\n\n/* === EMPTY STATES === */\n.empty-state,\n.error-state {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem 1rem;\n    text-align: center;\n}\n\n.empty-state p,\n.error-state p {\n    color: rgba(156, 163, 175, 0.6);\n    font-size: 0.875rem;\n    margin: 0;\n}\n\n.error-state p {\n    color: rgba(239, 68, 68, 0.7);\n}\n\n/* === RESPONSIVE DESIGN === */\n@media (max-width: 1200px) {\n    .insights-sidebar-redesigned {\n        width: 350px;\n    }\n    \n    .content-sections {\n        grid-template-columns: 1fr;\n        gap: 0.75rem;\n    }\n    \n    .content-card {\n        min-height: 280px;\n    }\n    \n    .insights-content {\n        padding: 0.75rem;\n        gap: 0.75rem;\n    }\n    \n    .insights-grid-layout {\n        min-height: 500px;\n    }\n}\n\n@media (max-width: 768px) {\n    .insights-sidebar-redesigned {\n        width: 100vw;\n        height: 100dvh; /* Use dynamic viewport height on mobile */\n        border-left: none;\n        border-top: 1px solid rgba(75, 85, 99, 0.2);\n    }\n    \n    .sidebar-backdrop {\n        display: block;\n    }\n    \n    .sidebar-toggle {\n        top: 10px;\n        right: 10px;\n        width: 40px;\n        height: 40px;\n    }\n    \n    .sidebar-toggle svg {\n        width: 18px;\n        height: 18px;\n    }\n    \n    .hero-card {\n        padding: 0.75rem;\n    }\n    \n    .hero-metrics {\n        justify-content: center;\n    }\n    \n    .overview-section {\n        padding: 0.75rem;\n    }\n    \n    .overview-metrics {\n        justify-content: center;\n        text-align: center;\n    }\n    \n    .content-card {\n        min-height: 220px;\n    }\n    \n    .card-header,\n    .card-content {\n        padding: 0.75rem;\n    }\n    \n    .related-items {\n        justify-content: center;\n    }\n    \n    .insights-content {\n        padding: 0.5rem;\n        gap: 0.5rem;\n    }\n    \n    .insights-grid-layout {\n        min-height: 400px;\n    }\n    \n    /* Enhanced Overview Responsive */\n    .overview-metrics-grid {\n        grid-template-columns: 1fr;\n        gap: 0.375rem;\n    }\n    \n    .overview-metric-card {\n        padding: 0.5rem;\n    }\n    \n    .overview-company-name {\n        font-size: 1rem;\n    }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
